// @flow
import React from 'react'
import classNames from 'classnames'
import WithDefaultIconProps from './WithDefaultIconProps'

const IconRefresh = (props: {analysisInProgress: boolean}) =>
  <svg
    {...props}
    className={classNames('request-analysis-icon', {'reverse-spin': props.analysisInProgress})}
    viewBox='0 0 1024 1024'
  >
    <g>
      <path d='M309.7,425.7L265.9,344l-67.9,36.4c21.9-54.7,57.4-102.6,102.7-139c58.3-46.9,132-74.8,212.7-74.8
                        c81.3,0,155.5,28.4,214,75.9c58.5,47.5,100.8,114,117.7,189.9l90.5-20.1c-21.5-96.9-75.4-181.4-149.7-241.8
                        c-74.3-60.3-169.3-96.6-272.4-96.6c-102.3,0-196.8,35.7-270.8,95.3c-57.6,46.3-102.8,107.2-130.7,177l-30.4-56.7L0,333.3
                        l107.6,200.8L309.7,425.7z' />
      <path d='M1024,690.7L916.4,489.9L714.3,598.3l43.8,81.7l67.9-36.4c-21.9,54.7-57.4,102.6-102.7,139c-58.3,46.9-132,74.8-212.7,74.8
                        c-81.3,0-155.5-28.4-214-75.9c-58.5-47.5-100.8-114-117.7-189.9l-90.5,20.1c21.5,96.9,75.4,181.4,149.7,241.8
                        c74.3,60.3,169.3,96.6,272.4,96.6c102.3,0,196.8-35.7,270.8-95.3c57.6-46.3,102.8-107.2,130.7-177l30.4,56.7L1024,690.7z' />
    </g>
  </svg>

export default WithDefaultIconProps(IconRefresh)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/icons/IconRefresh.js